import { reformatDateToDisplay } from "../../../objects/CommonUse/reformatDateToDisplay_function";
import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";
import createIconTableObj from "../objects/create_icon_table_obj";


export const createInvestPayoutText = (payOutArr, createIcon, iconTable, iconName) => {
    let iconAdditionalInfoArr = [];
    const arrow = '➜';
    let cashChg = 0;
    for (let i=0; i<payOutArr.length; i++){   
        const formatGameDate = reformatDateToDisplay(payOutArr[i].dateClosed);
        const additionalInfoObj = payOutArr[i].tranType + arrow + payOutArr[i].investmentName + ", Date: " + 
            formatGameDate + ", Amount: " + doubleToStringMonthly(payOutArr[i].sellAmount);
        iconAdditionalInfoArr.push(additionalInfoObj);
        cashChg += +payOutArr[i].sellAmount;
    }
    if (createIcon === true){
        createIconTableObj(iconName, iconTable, iconAdditionalInfoArr);
    }
    
    const returnObj = {cashChg: cashChg, additionalText: iconAdditionalInfoArr};
    return returnObj;
}
export default createInvestPayoutText;